define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var areaName = 'autosservico';
    exports.default = {
        isSelfService: function () {
            var paths = location.pathname.split('/');
            return paths.indexOf(areaName) !== -1;
        }
    };
});
